import { AppUrl } from "../../../../shared/setup/appUrl";
import { EnvironmentServiceType } from "./environment.service.type";
import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Injectable()
export class EnvironmentService implements EnvironmentServiceType {
  constructor(private title: Title) {}

  get baseUrl(): string {
    if (this.isPortal) {
      return AppUrl.portalWebUrl;
    }

    if (this.isOC) {
      return AppUrl.ocWebUrl;
    }

    if (this.isDB) {
      return AppUrl.dbWebUrl;
    }

    return AppUrl.baseWebUrl;
  }

  get isPortal(): boolean {
    return window.location.href.includes(AppUrl.portalWebUrl);
  }

  get isOC(): boolean {
    return window.location.href.includes(AppUrl.ocWebUrl);
  }

  get isDB(): boolean {
    return window.location.href.includes(AppUrl.dbWebUrl);
  }

  get isLocal(): boolean {
    return window.location.href.includes("localhost");
  }

  get isStaging(): boolean {
    return window.location.href.includes("staging.lcm-client.com");
  }

  get isProduction(): boolean {
    return window.location.href.includes("app.lcm-client.com");
  }

  setFavicon(target: HTMLElement): void {
    if (this.isOC) {
      target!.setAttribute("href", "assets/oc-favicon.png");
    }

    if (this.isPortal) {
      target!.setAttribute("href", "assets/om-portal-logo.png");
    }
  }

  setTitle(): void {
    if (this.isOC) {
      this.title.setTitle("Obsolescence Community");
    }

    if (this.isPortal) {
      this.title.setTitle("Obsolescence Management PORTAL");
    }
  }
}
